import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../components/Button';

import './EditAddress.less';

export default class EditAddress extends React.Component {
  static propTypes = {
    save: PropTypes.func.isRequired,
    cancel: PropTypes.func,
    address: PropTypes.object,
    errorMessage: PropTypes.string,
    buttonText: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.save = this.save.bind(this);
    this.onChange = this.onChange.bind(this);

    let address = props.address || {};

    this.state = {
      'name': address.name || '',
      'address1': address.address1 || '',
      'address2': address.address2 || '',
      'city': address.city || '',
      'state': address.state || '',
      'postal_code': address.postal_code || '',
      'instructions': address.instructions || ''
    };
  }

  save() {
    return this.props.save(this.state);
  }

  onChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  render() {
    let cancelDiv = this.props.cancel ? <div className="col-50"><Button color="white" onClick={this.props.cancel}>Cancel</Button></div> : null;

    let errorMessage = null;
    if (this.props.errorMessage) {
      errorMessage = <div className="error-message">{this.props.errorMessage}</div>;
    }

    let buttonRow = null;
    let saveButton = <Button className="full-width" onClick={this.save}>{this.props.buttonText || 'Save'}</Button>;
    if (cancelDiv) {
      buttonRow =
        <div className="row button-row">
          <div className="col-50">
            {saveButton}
          </div>
          {cancelDiv}
        </div>;
    } else {
      buttonRow =
        <div className="row button-row">
          {saveButton}
        </div>;
    }

    return (
      <div className="edit-address">
        <h2>Where should we send it?</h2>
        <EditAddressForm address={this.state} onChange={this.onChange} />
        {errorMessage}
        {buttonRow}
      </div>
    );
  }
}

const EditAddressForm = ({address, onChange}) =>
  <div className="edit-address-form">
    <div className="row2">
      <div className="input input-recipient">
        <label htmlFor="name">Recipient</label>
        <input className="input" type="text" name="name" onChange={onChange} value={address.name} />
      </div>
    </div>
    <div className="row2">
      <div className="input input-address1">
        <label>Address Line 1</label>
        <input className="input" type="text" name="address1" onChange={onChange} value={address.address1} />
      </div>
    </div>
    <div className="row2">
      <div className="input">
        <label>Address Line 2</label>
        <input className="input" type="text" name="address2" onChange={onChange} value={address.address2} />
      </div>
    </div>
    <div className="row2">
      <div className="input col-33 input-city">
        <label>City</label>
        <input className="input" type="text" name="city" onChange={onChange} value={address.city} />
      </div>
      <div className="input col-33 input-state">
        <label>State</label>
        <input className="input" type="text" name="state" onChange={onChange} value={address.state} />
      </div>
      <div className="input col-33 input-zip">
        <label>POSTAL CODE</label>
        <input className="input" type="text" name="postal_code" onChange={onChange} value={address.postal_code} />
      </div>
    </div>
    <div className="row2">
      <div className="input">
        <label>Instructions</label>
        <input className="input" type="text" name="instructions" onChange={onChange} value={address.instructions} />
      </div>
    </div>
  </div>
;

export { EditAddressForm };



/** WEBPACK FOOTER **
 ** ./src/views/checkout/EditAddress.js
 **/